import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Table from "@/components/common/table";
import { Pumps_List } from "../../../../tables-columns/Pumps-List";
import { Flow_Meters_List } from "../../../../tables-columns/Flow-Meters-List";
import { Pipes_List } from "../../../../tables-columns/Pipes-List";
import { Valves_List } from "../../../../tables-columns/Valves-List";
import { Drips_List } from "../../../../tables-columns/Drips-List";
import { CPF_Water_Sources_List } from "../../../../tables-columns/CPF-Water-Sources-List";
import { CPFـPivots } from "../../../../tables-columns/CPF-Pivots";
import Cookie from "js-cookie";
import axios from "axios";
import ActionButtons from "./ActionButtons/ActionButtons";
import { Water_Sources_List } from "../../../../tables-columns/Water-Sources-List";
import ValveModal from "./valveModalLeftSide/valveModal/index";
import { authServices } from "services/auth.services";
import EditModal from "./valveModalLeftSide/valveModal/editModal";
import WaterSourcesModal from "./water-sources/index";
import DeleteModal from "./confirmDlete";
import { ValveService } from "services/assets-valves.services";
import EditWaterSourceModal from "./water-sources/editModal";
import { WaterSourceService } from "services/assets-waterSource.servises";
import FlowMeterModal from "./flowMeter/index";
import EditFlowMeterModal from "./flowMeter/editModal";
import { WaterFlowService } from "services/assets-flowMeter.sevices";
import PumpModal from "./pump/index";
import EditPumpModal from "./pump/editModal";
import { PumpService } from "services/assets-pump.services";
import PipesModal from "./pipes/index";
import PivotModal from "./pivot/index";
import EditPivotModal from "./pivot/editModal";
import EditPipesModal from "./pipes/editModal";
import { PivotService } from "services/assets-pivot.service";
import Loader from "@/components/common/loader.components";
import PageTitle from "@/components/common/page-title.component";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
import {
  clearField,
  clearGeoField,
  readTreeFields,
  readTreeGeoFields,
  setTreeFieldData,
} from "@/redux/actions/tree/fields";
import { navigationServices } from "services/navigation.service";
import { setFarmData } from "@/redux/actions/farms";
import { setAlert } from "@/redux/actions/alert";

type RowData = {
  id?: any;
};
export default function IrrigationNetwork({}) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showWaterSourceModal, setShowWaterSourceModal] = useState(false);
  const [rowData, setRowData] = useState<RowData>({});
  const [columnsTabel, setColumnsTabel] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editWaterSourceModal, setEditWaterSourceModal] = useState(false);
  const [flowMetersModal, setFlowMetersModal] = useState(false);
  const [editFlowMetersModal, setEditFlowMetersModal] = useState(false);
  const [showPumpModal, setShowPumpModal] = useState(false);
  const [ShowEditPumpModal, setShowEditPumpModal] = useState(false);
  const [showPipesModal, setShowPipesModal] = useState(false);
  const [showPivotModal, setShowPivotModal] = useState(false);
  const [showEditPivotModal, setShowEditPivotModal] = useState(false);
  const [editPipesModal, setEditPipesModal] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setpage] = useState(1);
  const router = useRouter();
  const SubCategorie = router.query;
  useEffect(() => {
    if (editModal === false) {
      setRowData({});
    }
  }, [editModal]);

  const getModal = () => {
    if (SubCategorie.subInner === "valves") {
      return showModal;
    } else if (SubCategorie.subInner === "water-sources") {
      return showWaterSourceModal;
    } else if (SubCategorie.subInner === "flow-meters") {
      return flowMetersModal;
    }
  };
  const getSetShowModal = () => {
    if (SubCategorie.subInner === "valves") {
      return setShowModal;
    } else if (SubCategorie.subInner === "water-sources") {
      return setShowWaterSourceModal;
    } else if (SubCategorie.subInner === "flow-meters") {
      return setFlowMetersModal;
    } else if (
      SubCategorie.subInner === "pump" ||
      SubCategorie.subInner === "pumps"
    ) {
      return setShowPumpModal;
    } else if (SubCategorie.subInner === "pipes") {
      return setShowPipesModal;
    } else if (SubCategorie.subInner === "pivots") {
      return setShowPivotModal;
    }
  };
  const getDeletFunction = () => {
    if (SubCategorie.subInner === "valves") {
      return ValveService.deleteValve;
    } else if (SubCategorie.subInner === "water-sources") {
      return WaterSourceService.deleteWaterSource;
    } else if (SubCategorie.subInner === "flow-meters") {
      return WaterFlowService.deleteWaterFlow;
    } else if (
      SubCategorie.subInner === "pump" ||
      SubCategorie.subInner === "pumps"
    ) {
      return PumpService.deletePump;
    } else if (SubCategorie.subInner === "pivots") {
      return PivotService.deletePivot;
    } else if (SubCategorie.subInner === "pipes") {
      return WaterFlowService.deleteWaterFlow;
    }
  };
  const getSetShowEditModal = () => {
    if (SubCategorie.subInner === "valves") {
      return setEditModal(!showModal);
    } else if (SubCategorie.subInner === "water-sources") {
      return setEditWaterSourceModal(!editWaterSourceModal);
    } else if (SubCategorie.subInner === "flow-meters") {
      return setEditFlowMetersModal(!editFlowMetersModal);
    } else if (
      SubCategorie.subInner === "pump" ||
      SubCategorie.subInner === "pumps"
    ) {
      setShowEditPumpModal(!ShowEditPumpModal);
      return;
    } else if (SubCategorie.subInner === "pivots") {
      return setShowEditPivotModal(!showEditPivotModal);
    } else if (SubCategorie.subInner === "pipes") {
      return setEditPipesModal(!editPipesModal);
    }
  };

  useEffect(() => {
    setLoading(true);
    const getApiLink = () => {
      if (SubCategorie.subInner === "water-sources") {
        return `/water-sources/?org_id__id=${
          authServices.userValue.org_id
        }&content_type__model=${gitsubIner()}&page=${page}`;
      } else if (SubCategorie.subInner === "pivots") {
        return `/pivot-devices/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      } else if (SubCategorie.subInner === "pipes") {
        return `/water-network-items/?org_id__id=${authServices.userValue.org_id}&content_type__model=treefieldinfo&entity_type_id__prefix=PYP-&page=${page}
        `;
      } else {
        return `/water-network-items/?org_id__id=${
          authServices.userValue.org_id
        }&content_type__model=${gitsubIner()}&entity_type_id__prefix=${getCategory()}&page=${page}`;
      }
    };
    const gitsubIner = () => {
      if (SubCategorie.innerPage === "center-pivot-farming") {
        return "pivotfieldinfo";
      } else if (SubCategorie.innerPage === "tree-farming") {
        return "treefieldinfo";
      }
    };
    const getCategory = () => {
      if (SubCategorie.subInner === "valves") {
        return "VLV-";
      } else if (
        SubCategorie.subInner === "pump" ||
        SubCategorie.subInner === "pumps"
      ) {
        return "PMP-";
      } else if (SubCategorie.subInner === "drips") {
        return "DRP-";
      } else if (SubCategorie.subInner === "flow-meters") {
        return "WFM-";
      }
    };

    axios

      .get(getApiLink(), {
        headers: {
          Authorization: `Bearer ${Cookie.get("token")}`,
        },
      })
      .then((response) => {
        const data = response.data;
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [SubCategorie, page]);
  useEffect(() => {
    const getApiLink = () => {
      if (SubCategorie.subInner === "water-sources") {
        return `/water-sources/?org_id__id=${
          authServices.userValue.org_id
        }&content_type__model=${gitsubIner()}&page=${page}`;
      } else if (SubCategorie.subInner === "pivots") {
        return `/pivot-devices/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      } else if (SubCategorie.subInner === "pipes") {
        return `/water-network-items/?org_id__id=${authServices.userValue.org_id}&content_type__model=treefieldinfo&entity_type_id__prefix=PYP-&page=${page}
        `;
      } else {
        return `/water-network-items/?org_id__id=${
          authServices.userValue.org_id
        }&content_type__model=${gitsubIner()}&entity_type_id__prefix=${getCategory()}&page=${page}`;
      }
    };
    const gitsubIner = () => {
      if (SubCategorie.innerPage === "center-pivot-farming") {
        return "pivotfieldinfo";
      } else if (SubCategorie.innerPage === "tree-farming") {
        return "treefieldinfo";
      }
    };
    const getCategory = () => {
      if (SubCategorie.subInner === "valves") {
        return "VLV-";
      } else if (
        SubCategorie.subInner === "pump" ||
        SubCategorie.subInner === "pumps"
      ) {
        return "PMP-";
      } else if (SubCategorie.subInner === "drips") {
        return "DRP-";
      } else if (SubCategorie.subInner === "flow-meters") {
        return "WFM-";
      }
    };

    axios
      .get(getApiLink(), {
        headers: {
          Authorization: `Bearer ${Cookie.get("token")}`,
        },
      })
      .then((response) => {
        const data = response.data;
        setRefresh(0);
        setTableData(data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [refresh === 1]);

  const getFarmingType = () => {
    if (SubCategorie.innerPage === "center-pivot-farming") {
      return "crop";
    } else if (SubCategorie.innerPage === "tree-farming") {
      return "tree";
    }
  };

  const dispatch = useDispatch();

  const tableActions = [
    {
      title: "view",
      action(row: any) {},
    },
    {
      title: "edit",

      async action(row: any) {
        setRowData(row.original);
        getSetShowEditModal();
        dispatch(clearField());
        dispatch(clearGeoField());
        await dispatch(readTreeFields(`?farm_id__id=${row.original.farm_id}`));
        await dispatch(readTreeGeoFields(row.original.farm_id)).then((res) => {
          dispatch(
            setTreeFieldData({
              key: "geo_field",
              value: res.data?.find?.(
                (item) => Number(item.id) === Number(row.original.id) ?? {}
              ),
            })
          );
        });

        dispatch(
          setTreeFieldData({
            key: "field",
            value: row.original,
          })
        );

        let fieldGeo, farm, farmGeo;
        farm = await navigationServices.getFarm(row.original.farm_id);
        if (farm) {
          dispatch(
            setFarmData({
              key: "farm",
              value: farm?.data,
            })
          );
        }
        fieldGeo = await navigationServices.getGboundry(
          row.original.gboundary_id ?? null
        );

        farmGeo = await navigationServices.getGboundry(
          farm?.data?.gboundary_id ?? null
        );
        if (farmGeo) {
          dispatch(
            setFarmData({
              key: "geo_farm",
              value: farmGeo?.data,
            })
          );
        }
        if (!farmGeo || !fieldGeo || !farm) {
          dispatch(
            setAlert({
              message: "Something went wrong!!",
              status: "error",
              priority: "high",
            })
          );
        }
      },
    },

    {
      title: "delete",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("delete")
          ? (setRowData(row.original), setShowDeleteModal(!showDeleteModal))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },
  ];
  const columns = [
    {
      label: "Water Sources",
      path: "center-pivot-farming/water-sources",
      columns: CPF_Water_Sources_List(t),
    },
    {
      label: "Pumps",
      path: "center-pivot-farming/pumps",
      columns: Pumps_List(t),
    },
    {
      label: "Flow Meters",
      path: "center-pivot-farming/flow-meters",
      columns: Flow_Meters_List(t),
    },
    {
      label: "Pivots",
      path: "center-pivot-farming/pivots",
      columns: CPFـPivots(t),
    },

    {
      label: "Water Sources",
      path: "tree-farming/water-sources",
      columns: Water_Sources_List(t),
    },
    {
      label: "Pump",
      path: "tree-farming/pump",
      columns: Pumps_List(t),
    },
    {
      label: "Flow Meters",
      path: "tree-farming/flow-meters",
      columns: Flow_Meters_List(t),
    },
    {
      label: "Pipes",
      path: "tree-farming/pipes",
      columns: Pipes_List(t),
    },
    {
      label: "Valves",
      path: "tree-farming/valves",
      columns: Valves_List(t),
    },
    {
      label: "Drips",
      path: "tree-farming/drips",
      columns: Drips_List(t),
    },
  ];
  useEffect(() => {
    const getColumns = columns.filter(
      (element) =>
        element.path === `${SubCategorie.innerPage}/${SubCategorie.subInner}`
    );
    setColumnsTabel(getColumns[0]?.columns);
  }, [SubCategorie]);

  const EditModals = () => {
    if (SubCategorie.subInner === "valves") {
      return (
        <EditModal
          setRefresh={setRefresh}
          setRowData={setRowData}
          rowData={rowData}
          showModal={editModal}
          setShowModal={setEditModal}
        />
      );
    } else if (SubCategorie.subInner === "water-sources") {
      return (
        <EditWaterSourceModal
          setRefresh={setRefresh}
          showModal={editWaterSourceModal}
          setShowModal={setEditWaterSourceModal}
          setRowData={setRowData}
          rowData={rowData}
          type={getFarmingType()}
        />
      );
    } else if (SubCategorie.subInner === "flow-meters") {
      return (
        <EditFlowMeterModal
          setRefresh={setRefresh}
          showModal={editFlowMetersModal}
          setShowModal={setEditFlowMetersModal}
          setRowData={setRowData}
          rowData={rowData}
          type={getFarmingType()}
        />
      );
    } else if (
      SubCategorie.subInner === "pump" ||
      SubCategorie.subInner === "pumps"
    ) {
      return (
        <EditPumpModal
          setRefresh={setRefresh}
          showModal={ShowEditPumpModal}
          setShowModal={setShowEditPumpModal}
          setRowData={setRowData}
          rowData={rowData}
          type={getFarmingType()}
        />
      );
    } else if (SubCategorie.subInner === "pivots") {
      return (
        <EditPivotModal
          setRefresh={setRefresh}
          setRowData={setRowData}
          rowData={rowData}
          type={getFarmingType()}
          showModal={showEditPivotModal}
          setShowModal={setShowEditPivotModal}
        />
      );
    } else if (SubCategorie.subInner === "pipes") {
      return (
        <EditPipesModal
          setRefresh={setRefresh}
          showModal={editPipesModal}
          setShowModal={setEditPipesModal}
          setRowData={setRowData}
          rowData={rowData}
        />
      );
    } else {
      return <div></div>;
    }
  };
  const Modals = () => {
    if (SubCategorie.subInner === "valves") {
      return (
        <ValveModal
          setRefresh={setRefresh}
          showModal={showModal}
          setShowModal={setShowModal}
          gboundary={{}}
        />
      );
    } else if (SubCategorie.subInner === "water-sources") {
      return (
        <WaterSourcesModal
          setRefresh={setRefresh}
          showModal={showWaterSourceModal}
          setShowModal={setShowWaterSourceModal}
          type={getFarmingType()}
          gboundary={{}}
        />
      );
    } else if (SubCategorie.subInner === "flow-meters") {
      return (
        <FlowMeterModal
          setRefresh={setRefresh}
          showModal={flowMetersModal}
          setShowModal={setFlowMetersModal}
          type={getFarmingType()}
          gboundary={{}}
          setOpenModel={undefined}
        />
      );
    } else if (
      SubCategorie.subInner === "pump" ||
      SubCategorie.subInner === "pumps"
    ) {
      return (
        <PumpModal
          setRefresh={setRefresh}
          showModal={showPumpModal}
          setShowModal={setShowPumpModal}
          type={getFarmingType()}
        />
      );
    } else if (SubCategorie.subInner === "pipes") {
      return (
        <PipesModal
          setRefresh={setRefresh}
          showModal={showPipesModal}
          setShowModal={setShowPipesModal}
          gboundary={{}}
          setOpenModel={undefined}
        />
      );
    } else if (SubCategorie.subInner === "pivots") {
      return (
        <PivotModal
          setRefresh={setRefresh}
          showModal={showPivotModal}
          setShowModal={setShowPivotModal}
          gboundary={{}}
          setOpenModel={undefined}
        />
      );
    } else {
      return <div></div>;
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <PageTitle
          title={[t("Assets"), t(`${SubCategorie.subInner}`)]}
          hasLink={true}
          link="/assets"
        />
        <ActionButtons
          show={getModal()}
          setShow={getSetShowModal()}
          label={t(`${SubCategorie.subInner}`)}
          type={getFarmingType()}
        />
      </div>

      <Table
        fillPage={true}
        columns={columnsTabel}
        data={tableData.results ?? []}
        tableAction={tableActions}
        manualPageination={true}
        totalPages={tableData.total_pages}
        goToPage={(currentPage) => setpage(currentPage)}
        crntpage={page}
      />

      <EditModals />
      <Modals />

      <DeleteModal
        setRefresh={setRefresh}
        id={rowData?.id ?? null}
        setShowModel={setShowDeleteModal}
        showModel={showDeleteModal}
        deleteTrigger={getDeletFunction()}
        /* mutate={mutate} */
      />
    </div>
  );
}
